import styled from 'styled-components';
import { Colors } from '@fourthwall/components';
export const Container = styled.div `
  display: grid;

  gap: 24px;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;
`;
export const Artwork = styled.img `
  height: 100px;
  width: 100px;
  object-fit: cover;
`;
export const Right = styled.div `
  display: grid;
  gap: 4px;
`;
export const Title = styled.div `
  font-weight: 600;
  line-height: 1.5;

  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
export const Description = styled.div `
  color: ${Colors.GS600};

  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
